export const FIELD_MODIFICATION_TYPE = {
  NON_PRICING_AMENDEMENT: 1,
  PRICING_AMENDEMENT: 2,
  MANAGEMENT_ACT: 3,
};
